<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          plain
          @click="exportAttendanceRecord()"
          size="small"
          icon="el-icon-top-right"
          :disabled="tableData.length == 0"
          >导出</el-button
        >
      </div>
      <div class="search_box">
        <el-cascader
          :options="departmentHead"
          v-model="testUserInfo.userId"
          @change="selectDepartmentHead"
          ref="departmentHeadSelect"
          size="mini"
          filterable
          clearable
          placeholder="请选择打卡人"
        >
          <template slot-scope="{ node, data }">
            <span>{{ data.label }}</span>
            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
          </template>
        </el-cascader>
        <el-select
          v-model="searchParams.status"
          clearable
          size="mini"
          placeholder="请选择状态"
        >
          <el-option
            v-for="item in $store.state.select.clockInStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-date-picker
          clearable
          size="mini"
          :picker-options="pickerDateOptionsOne"
          v-model="searchParams.timer"
          type="date"
          placeholder="选择日期"
          value-format="timestamp"
        >
        </el-date-picker>
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          v-loading="tableLoading"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                searchParams.pageSize * (searchParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="inTime"
            label="最早打卡时间"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.inTime != 0">{{
                $Common.dateFormatDate(scope.row.inTime)
              }}</span>
              <span v-else>暂未打上班卡</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="outTime"
            label="最晚打卡时间"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.outTime != 0">{{
                $Common.dateFormatDate(scope.row.outTime)
              }}</span>
              <span v-else>暂未打下班卡</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="打卡状态"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ $store.state.select.clockInStatus[scope.row.status].name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="addTime"
            label="添加时间"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ $Common.dateFormatDate(scope.row.addTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户名"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="departmentName"
            label="部门名称"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-size="searchParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AttendanceRecord",
  data() {
    return {
      pickerDateOptionsOne: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      searchParams: {
        pageNum: 1,
        pageSize: 20,
        schoolId: this.$store.state.schoolId,
        userId: "",
        status: "",
        timer: ""
      },
      tableData: [],
      tableLoading: false,
      total: 0,
      // 部门负责人
      departmentHead: [],
      testUserInfo: {
        userId: ""
      }
    };
  },
  mounted() {
    this.getList();
    this.getDepartmentHead();
  },
  methods: {
    searchData(){

      this.searchParams.pageNum = 1;
    this.getList();
    },
    async getList() {
      this.tableLoading = true;
      let req = Object.assign({}, this.searchParams);
      if (req.timer) {
        req.timer = parseInt(req.timer) / 1000;
      } else {
        req.timer = "";
      }
      // console.log(req)
      let res = await this.$Http.getAttendanceRecord(req);
      this.tableLoading = false;
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "考勤记录获取失败"
        });
        this.tableData = [];
        this.total = 0;
      }
    },
    async exportAttendanceRecord() {
      let req = Object.assign({}, this.searchParams);
      if (req.timer) {
        req.timer = parseInt(req.timer) / 1000;
      } else {
        req.timer = "";
      }
      this.$Common.exportData(req, "exportAttendanceRecord", "考勤记录");
    },
    // 选择负责人(新增任务时使用)
    selectDepartmentHead(data) {
      // console.log(this.testUserInfo)
      // console.log(data)
      // console.log(node)
      // var newData = this.$refs.departmentHeadSelect.getCheckedNodes()
      // console.log(newData)
      if (data.length > 0) {
        let value = this.$refs.departmentHeadSelect.panel.getNodeByValue(
          this.testUserInfo.userId
        ).data.thisId;
        // console.log(value)
        // console.log(newData[0].data.thisId);
        this.searchParams.userId = value;
      } else {
        this.searchParams.userId = "";
      }
      // console.log(this.searchParams.userId)
      // this.searchParams.userId = newData[0].data.thisId
    },
    // 获取部门及负责人
    async getDepartmentHead() {
      var _this = this;
      var paramData = {
        schoolId: this.searchParams.schoolId
      };
      let res = await this.$Http.getDepartmentHead(paramData, true);
      if (res.code == 200) {
        // this.departmentHead = res.data
        _this.selectedPersonList = [];
        var departmentHeadList = [];
        for (var keyOne in res.data) {
          var thisUserList = [];
          for (var keyTwo in res.data[keyOne].dlist) {
            // 负责人默认选择
            if (
              this.searchParams.userId == res.data[keyOne].dlist[keyTwo].userId
            ) {
              this.testUserInfo.userId = [];
              this.testUserInfo.userId.push(keyOne);
              this.testUserInfo.userId.push(keyOne + "-" + keyTwo);
            }

            // 巡查人员默认选择
            if (
              this.searchParams.dailyTaskTimeStatus == 1 &&
              this.searchParams.timeQuantumList.length >= 1
            ) {
              var selectedUserInfo = Object.assign(
                {},
                this.searchParams.timeQuantumList[0]
              );
              var selectedUserList = selectedUserInfo.userIdArray
                ? selectedUserInfo.userIdArray.split(",")
                : [];
              selectedUserList.forEach((element) => {
                if (element == res.data[keyOne].dlist[keyTwo].userId) {
                  var personUserGroup = [];
                  personUserGroup.push(keyOne);
                  personUserGroup.push(keyOne + "-" + keyTwo);
                  _this.selectedPersonList.push(personUserGroup);
                }
              });
            } else if (
              this.searchParams.dailyTaskTimeStatus == 0 &&
              this.searchParams.timeQuantumList.length >= 1
            ) {
              for (var i = 0; this.inspectionPeriod.length > i; i++) {
                var selectedUserList = this.inspectionPeriod[i].userIdArray
                  ? this.inspectionPeriod[i].userIdArray.split(",")
                  : [];
                selectedUserList.forEach((element) => {
                  if (element == res.data[keyOne].dlist[keyTwo].userId) {
                    var personUserGroup = [];
                    personUserGroup.push(keyOne);
                    personUserGroup.push(keyOne + "-" + keyTwo);
                    this.inspectionPeriod[i].userIdString.push(personUserGroup);
                  }
                });
              }
            }

            var newThisData = {
              value: keyOne + "-" + keyTwo,
              label: res.data[keyOne].dlist[keyTwo].userName,
              thisId: res.data[keyOne].dlist[keyTwo].userId,
              thisLevel: 2
            };
            thisUserList.push(newThisData);
          }

          departmentHeadList[keyOne] = {
            value: keyOne,
            label: res.data[keyOne].departmentName,
            thisId: res.data[keyOne].departmentId,
            thisLevel: 1,
            children: thisUserList
          };
        }
        this.departmentHead = departmentHeadList;
        // console.log(this.inspectionPeriod)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchParams.pageNum = val || 1;
      this.getList();
    }
  }
};
</script>
